import { FaSolidUser } from 'solid-icons/fa'
import { Component, For, JSX, createMemo, useContext } from "solid-js"
import { Engine } from '../../lib/core/engine/Engine.type'
import findById from '../../lib/core/findById'
import createSelectedPlayerMemo from '../../lib/core/player/createSelectedPlayerMemo'
import { Player } from '../../lib/core/player/Player.type'
import playerColorToHex from '../../lib/core/player/playerColorToHex'
import playerDisplayName from '../../lib/core/player/playerDisplayName'
import { Nullable } from '../../typescript'
import EngineContext from '../EngineContext'
import { useSelectedPlayerIdSignal } from '../../rx/signal/useSelectedPlayerIdSignal'

const SelectPlayerInput: Component = () => {
  const engine: Engine = useContext(EngineContext)
  const [getSelectedPlayerId, setSelectedPlayerId] = useSelectedPlayerIdSignal(engine)

  const selectedPlayer = createSelectedPlayerMemo(engine)

  function setPlayer(player: Nullable<Player>): void {
    // console.log('SelectPlayerInput.setPlayer()', player?.dname || null)
    setSelectedPlayerId(player?.id || null)
  }

  const iconSpanStyles = createMemo<JSX.CSSProperties | undefined>(() => {
    const player = selectedPlayer()
    // console.log('createMemo.iconSpanStyles.player', player?.dname || null)
    if (player && player.color1) {
      return {
        color: playerColorToHex(player.color1),
        'border-color': playerColorToHex(player.color2),
      }
    }
    return {}
  })
  // createEffect(() => {
  //   console.log('iconSpanStyles', iconSpanStyles())
  // })

  return <div class="input-group">
    <span class="input-group-text" style={iconSpanStyles()}>
      <FaSolidUser />
    </span>
    <select name="selected_player_id" class="form-select" aria-label="Select Current Player"
      onChange={(event) => {
        // console.log(event, event.currentTarget.value)
        const player_id = parseInt(event.currentTarget.value)
        const player = findById(engine.state.players, player_id)
        setPlayer(player)
      }}
    >
      <option selected={!getSelectedPlayerId()}>None (neutral)</option>
      <For each={engine.state.players}>{(player: Player) => {
        return <option selected={getSelectedPlayerId() === player.id} value={player.id}>
          {playerDisplayName(player)}
        </option>
      }}</For>
    </select>
  </div>
}

export default SelectPlayerInput
